import { lazy, type ComponentType } from "react";

const RELOAD_KEY = "chunk-reload-at";

/**
 * Lazily loads a route, but if the chunk file is missing (stale build after a
 * new deploy), retries once and then force-reloads the page so the browser
 * fetches the fresh asset manifest instead of showing a blank screen.
 */
export function lazyWithReload<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>,
) {
  return lazy(async () => {
    try {
      return await factory();
    } catch (err) {
      // one quick retry (transient network hiccup)
      try {
        return await factory();
      } catch {
        const last = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
        if (Date.now() - last > 10000) {
          sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
          window.location.reload();
          // never resolves; page is reloading
          return await new Promise<{ default: T }>(() => {});
        }
        throw err;
      }
    }
  });
}
